export async function getPlaceDetails(
	placeId: string,
	placesService?: google.maps.places.PlacesService,
): Promise<google.maps.places.PlaceResult | null> {
	const requestedFields = ['address_components'];

	if (!placesService) {
		return null;
	}

	// eslint-disable-next-line promise/avoid-new
	const result = await new Promise<google.maps.places.PlaceResult>((resolve, reject) => {
		placesService.getDetails({ placeId, fields: requestedFields }, (details, status) => {
			if (status === google.maps.places.PlacesServiceStatus.OK && details) {
				resolve(details);
			} else {
				reject(new Error(`Failed to get place details: ${status}`));
			}
		});
	});

	return result;
}
